const getDate = () => {
  const date = new Date();
  const dateFormat = {
    day: "numeric",
    month: "short"
  };
  return date.toLocaleDateString("en-us", dateFormat);
};

export default getDate;